import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

interface MyParams extends ICellRendererParams {
    onClick: Function,
    icon: string,
    array: string
}

@Component({
    selector: 'cell-button',
  template: `
<button *ngIf="hasValue()" (click)="onClick()" type="button" style="width: 60px;" title="{{params.Tooltip}}">
        <mat-icon class="iconsize-16 mat-icon material-icons">{{icon}}</mat-icon>
    </button>
    `,
})
export class CellButtonComponent implements ICellRendererAngularComp {
    public params: MyParams;
    public icon: string;

    agInit(params: any): void {
        this.params = params;        
        this.icon = params.icon;
    }

    public invokeParentMethod() {
        //   this.params.context.componentParent.methodFromParent(`Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef.headerName}`)
    }

    refresh(): boolean {
        return false;
    }

    onClick() {
        if (this.params.onClick)
            this.params.onClick(this.params);
    }

    hasValue() {
        if (this.params.value) {
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/grid/buttons/cell-button.component.ts